import React from "react";
import { Link } from "react-router-dom";
import PropTypes from 'prop-types';
import Footer from './Footer';
import TechnologyChips from './TechnologyChips';

const PortfolioDetailComponent = ({ item }) => {
  const { 
    title = '', 
    src = '', 
    desc = '', 
    date = '', 
    category = '', 
    link = '',
    technologies = '',
    technologyLinks = {},
    flagshipTech = '',
  } = item || {};

  const imageSrc = Array.isArray(src) ? src[0] : src;

  return (
    <div className="min-h-screen bg-background-dark text-slate-100 font-display">
      <main className="container mx-auto px-6 pt-32 pb-16">
        <div className="grid lg:grid-cols-2 gap-12 items-start">
          <div className="relative">
            <img 
              src={imageSrc} 
              alt={`${title} project screenshot`} 
              className="w-full rounded-2xl shadow-xl hover:scale-[1.02] transition-transform duration-300 border border-accent/10"
              onError={(e) => {
                e.target.src = '/fallback-image.jpg';
                e.target.alt = 'Image not available';
              }}
            />
          </div>
          <div>
            <h1 className="text-3xl lg:text-4xl font-bold text-slate-100 mb-4">
              {title}
            </h1>
            
            <div className="mb-6 flex gap-2 flex-wrap">
              <span className="px-3 py-1 bg-slate-800/50 text-slate-300 rounded-full text-sm border border-accent/10">
                {category}
              </span>
              <span className="px-3 py-1 bg-slate-800/50 text-slate-300 rounded-full text-sm border border-accent/10">
                {date}
              </span>
            </div>

            <p className="text-slate-400 mb-6 leading-relaxed text-lg">
              {desc}
            </p>

            <div className="mb-6">
              <h2 className="text-xl font-semibold text-slate-100 mb-2">Technologies Used</h2>
              <TechnologyChips technologies={technologies} technologyLinks={technologyLinks} flagshipTech={flagshipTech} />
            </div>

            {link && (
              <div className="mb-8">
                <a 
                  href={link} 
                  target="_blank" 
                  rel="noreferrer"
                  className="inline-flex items-center space-x-2 bg-accent text-background-dark hover:bg-accent/90 px-6 py-3 rounded-xl font-semibold transition-all duration-300 hover:shadow-lg"
                  aria-label={`Visit ${title} website`}
                >
                  <span>View Live Site</span>
                  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                  </svg>
                </a>
              </div>
            )}
          </div>
        </div>
        
        <div className="mt-12">
          <Link 
            to="/portfolio" 
            className="inline-flex items-center space-x-2 border border-accent/30 text-accent hover:bg-accent/5 px-6 py-3 rounded-xl font-semibold transition-all duration-300"
            aria-label="Return to portfolio"
          >
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
            </svg>
            <span>Back to Portfolio</span>
          </Link>
        </div>
      </main>
      <Footer />
    </div>
  );
};

PortfolioDetailComponent.propTypes = {
  item: PropTypes.shape({
    title: PropTypes.string,
    src: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
    desc: PropTypes.string,
    date: PropTypes.string,
    category: PropTypes.string,
    link: PropTypes.string,
    technologies: PropTypes.string,
    technologyLinks: PropTypes.objectOf(PropTypes.string),
    flagshipTech: PropTypes.string,
  }),
};

export default PortfolioDetailComponent;
